module.exports = __webpack_public_path__ + "static/img/电子发票.9c6803e.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/电子发票.png
// module id = UH3q
// module chunks = 2